import { defaultTemplate, widgetAction, userConstants } from "../constants";

const initialState = {
  resultsTemplate: [
    {
      type: "f95bd230-b3c0-41fd-aaf4-4738faa75ac2",
      uid: "widget1554257805640",
      layout: {
        i: "widget1554257805640",
        x: 0,
        y: 0,
        w: 4,
        h: 5,
      },
      uiState: {
        title: "概念矩陣",
        controller: [],
        chartType: "treemap",
        dashboard: false,
        mapColor: [
          "#92BEEB",
          "#FDC59A",
          "#F3E9D2",
          "rgb(255, 180, 175)",
          "#C6DABF",
          "#F3E9D2",
          "#1A936F",
          "#ffea96",
        ],
        colorForm: "預設",
      },
    },
    // {
    //   type: "1a3384ed-17f9-43d0-a3a6-350f2f92c292",
    //   uid: "010",
    //   layout: {
    //     i: "010",
    //     x: 0,
    //     y: 5,
    //     w: 2,
    //     h: 5,
    //   },
    //   uiState: {
    //     title: "媒體來源",
    //     controller: [],
    //     chartType: "pie",
    //     posttype: "",
    //     sentiment: "",
    //     voice: 1,
    //     contentListOpen: false,
    //     dashboard: false,
    //   },
    // },
    // {
    //   type: "9f80cf4c-9467-49cf-9226-507ecee12cb6",
    //   uid: "011",
    //   layout: {
    //     i: "011",
    //     x: 2,
    //     y: 5,
    //     w: 2,
    //     h: 5,
    //   },
    //   uiState: {
    //     title: "情緒聲量",
    //     controller: [],
    //     chartType: "line",
    //     controller: [],
    //     chartType: "line",
    //     posttype: "",
    //     voice: 1,
    //     dashboard: false,
    //   },
    // },
    {
      type: "355a4d6f-12a8-49e8-af27-a40b94602088",
      uid: "012",
      layout: {
        i: "012",
        x: 0,
        y: 10,
        w: 4,
        h: 5,
      },
      uiState: {
        title: "搜尋結果列表",
        controller: [],
        chartType: "",
        dashboard: false,
      },
    },
    // {
    // 	"type": '3dc8fd29-247a-4712-be07-368173262592',
    // 	"uid": "kollll",
    // 	"layout": {
    // 		"i": "kollll",
    // 		"x": 0,
    // 		"y": 0,
    // 		"w": 4,
    // 		"h": 5
    // 	},
    // 	"uiState": {
    // 		"title": "個人影響力",
    // 		"controller": [],
    // 		"chartType": "bar",
    // 		"posttype": "",
    // 		"sentiment": "",
    // 		"voice": 1,
    // 		"dashboard": false
    // 	},
    // },
    // {
    // 	"type": '355a4d6f-12a8-49e8-af27-a40b94602088',
    // 	"uid": "777",
    // 	"layout": {
    // 		"i": "777",
    // 		"x": 0,
    // 		"y": 10,
    // 		"w": 4,
    // 		"h": 5
    // 	},
    // 	"uiState": {
    // 		"title": "搜尋結果列表",
    // 		"controller": [],
    // 		"chartType": ""
    // 	}
    // },
    // {
    // 	"type": '9f80cf4c-9467-49cf-9226-507ecee12cb6',
    // 	"uid": "widget1551257324668",
    // 	"layout": {
    // 		"i": "widget1551257324668",
    // 		"x": 0,
    // 		"y": 0,
    // 		"w": 4,
    // 		"h": 5
    // 	},
    // 	"uiState": {
    // 		"title": "情緒聲量",
    // 		"controller": [],
    // 		"chartType": "line",
    // 		"dashboard": false
    // 	},
    // },
    // {
    // 	"type": 'f95bd230-b3c0-41fd-aaf4-4738faa75ac2',
    // 	"uid": "widget1551257318428",
    // 	"layout": {
    // 		"i": "widget1551257318428",
    // 		"x": 0,
    // 		"y": 0,
    // 		"w": 4,
    // 		"h": 5
    // 	},
    // 	"uiState": {
    // 		"title": "概念矩陣",
    // 		"controller": [],
    // 		"chartType": "treemap",
    // 		"dashboard": false,
    // 		"mapColor": ['#92BEEB', '#FDC59A', '#F3E9D2', 'rgb(255, 180, 175)', '#C6DABF', '#F3E9D2', '#1A936F', '#ffea96'],
    // 		"colorForm": '預設'
    // 	},
    // },
    // {
    // 	"type": '1a3384ed-17f9-43d0-a3a6-350f2f92c292',
    // 	"uid": "widget1551257329550666",
    // 	"layout": {
    // 		"i": "widget1551257329550666",
    // 		"x": 0,
    // 		"y": 0,
    // 		"w": 4,
    // 		"h": 5
    // 	},
    // 	"uiState": {
    // 		"title": "媒體來源",
    // 		"controller": [],
    // 		"chartType": "pie",
    // 		"dashboard": false
    // 	},
    // },
    // {
    // 	"type": '1a3384ed-17f9-43d0-a3a6-350f2f92c292',
    // 	"uid": "widget1551257329550",
    // 	"layout": {
    // 		"i": "widget1551257329550",
    // 		"x": 0,
    // 		"y": 0,
    // 		"w": 2,
    // 		"h": 5
    // 	},
    // 	"uiState": {
    // 		"title": "媒體來源",
    // 		"controller": [],
    // 		"chartType": "bar",
    // 		"dashboard": false
    // 	},
    // },
    // {
    // 	"type": '1a3384ed-17f9-43d0-a3a6-350f2f92c292',
    // 	"uid": "widget1551257326902",
    // 	"layout": {
    // 		"i": "widget1551257326902",
    // 		"x": 0,
    // 		"y": 5,
    // 		"w": 4,
    // 		"h": 5
    // 	},
    // 	"uiState": {
    // 		"title": "媒體來源",
    // 		"controller": [],
    // 		"chartType": "report",
    // 		"dashboard": false
    // 	},
    // 	"data": {
    // },
    // {
    // 	"type": '9f80cf4c-9467-49cf-9226-507ecee12cb6',
    // 	"uid": "widget1551257322935",
    // 	"layout": {
    // 		"i": "widget1551257322935",
    // 		"x": 0,
    // 		"y": 0,
    // 		"w": 2,
    // 		"h": 5
    // 	},
    // 	"uiState": {
    // 		"title": "情緒聲量",
    // 		"controller": [],
    // 		"chartType": "pie",
    // 		"dashboard": false
    // 	},
    //
    // },
    // {
    // 	"type": 'f95bd230-b3c0-41fd-aaf4-4738faa75ac2',
    // 	"uid": "widget1551257316273",
    // 	"layout": {
    // 		"i": "widget1551257316273",
    // 		"x": 2,
    // 		"y": 13.5,
    // 		"w": 2,
    // 		"h": 5
    // 	},
    // 	"uiState": {
    // 		"title": "概念探索",
    // 		"controller": [],
    // 		"chartType": "treemap",
    // 		"dashboard": false
    // 	},
    //
    // },
    // {
    // 	"type": 3,
    // 	"uid": "widget1551257241609",
    // 	"layout": {
    // 		"i": "widget1551257241609",
    // 		"x": 0,
    // 		"y": 18,
    // 		"w": 4,
    // 		"h": 6
    // 	},
    // 	"uiState": {
    // 		"title": "搜尋結果列表",
    // 		"controller": [],
    // 		"chartType": "",
    // 		"dashboard": false
    // 	},
    //
    // }
  ],
  dashboardTemplate: [],
  isFetching: false,
  rerenderWidgets: null,
  initWidgetTemplate: [],
};

export function widget(state = initialState, action) {
  switch (action.type) {
    case defaultTemplate.REQUEST:
      return { ...state, lastUpdated: action.receivedAt };
    case defaultTemplate.RECEIVE:
      return {
        resultsTemplate: action.resultsTemplate,
        fetched: true,
        lastUpdated: action.receivedAt,
      };
    case widgetAction.INITSET:
      return{
        ...state,
        initWidgetTemplate:state.resultsTemplate,
        lastUpdated: action.receivedAt,
      }
    case widgetAction.OUT:
      return{
        ...state,
        resultsTemplate:state.initWidgetTemplate,
        lastUpdated: action.receivedAt,
      }
    case widgetAction.ADD:
      return {
        ...state,
        resultsTemplate: action.newWidget.concat(state.resultsTemplate),
        lastUpdated: action.receivedAt,
      };
    case widgetAction.REMOVE_RESULT_WIDGET:
      return {
        ...state,
        resultsTemplate: [
          ...state.resultsTemplate.slice(0, action.removeTarget),
          ...state.resultsTemplate.slice(action.removeTarget + 1),
        ],
        lastUpdated: action.receivedAt,
      };
    case widgetAction.REMOVE_DASHBOARD_WIDGET:
      return {
        ...state,
        dashboardTemplate: [
          ...state.dashboardTemplate.slice(0, action.removeTarget),
          ...state.dashboardTemplate.slice(action.removeTarget + 1),
        ],
        lastUpdated: action.receivedAt,
      };
    case widgetAction.RESIZE_RESULTPAGE:
      return {
        ...state,
        resultsTemplate: action.newSizeTempalte.concat(action.fakewidget),
        rerenderWidgets: action.rerenderWidgets,
        lastUpdated: action.receivedAt,
      };
    case widgetAction.RESIZEWITHFAKER_RESULTPAGE:
      return {
        ...state,
        resultsTemplate: action.newSizeTempalte,
        rerenderWidgets: action.rerenderWidgets,
        lastUpdated: action.receivedAt,
      };
    case widgetAction.RESIZE_DASHBOARD:
      return {
        ...state,
        dashboardTemplate: action.newSizeTempalte.concat(action.fakewidget),
        rerenderWidgets: action.rerenderWidgets,
        lastUpdated: action.receivedAt,
      };
    case widgetAction.RESIZEWITHFAKER_DASHBOARD:
      return {
        ...state,
        dashboardTemplate: action.newSizeTempalte,
        rerenderWidgets: action.rerenderWidgets,
        lastUpdated: action.receivedAt,
      };
    case widgetAction.CHANGELAYOUT_RESULTPAGE:
      return {
        ...state,
        resultsTemplate: action.newLayoutTempalte,
        lastUpdated: action.receivedAt,
      };
    case widgetAction.CHANGELAYOUT_DASHBOARD:
      return {
        ...state,
        dashboardTemplate: action.newLayoutTempalte,
        lastUpdated: action.receivedAt,
      };
    case userConstants.DASH_CONTENT_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case userConstants.DASH_CONTENT_RECEIVE:
      return {
        ...state,
        isFetching: false,
        dashboardTemplate: action.dashboardWidgets,
      };
    case userConstants.USER_TEMPLATE_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case userConstants.USER_TEMPLATE_RECEIVE:
      return {
        ...state,
        isFetching: false,
        resultsTemplate: action.usertemplate,
      };
    case widgetAction.DEMO:
      return {
        ...state,
        resultsTemplate: action.demoTemplate,
        lastUpdated: action.receivedAt,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/widget.reducer.js